import { filterOptions } from '@/utils/query-base'

const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])

export const pageSearch = {
  '营销中心': {
    title: '省份',
    type: 'select',
    equation: city,
    dictionary: 'sale'
  },
  'brand_bq': {
    title: '品牌',
    type: 'select',
    equation: city,
    dictionary: 'A0018'
  },
  'cust_name': {
    title: '计划类型',
    type: 'select',
    equation: city,
    dictionary: 'A0002'
  },
  'customer_type': {
    title: '年份',
    equation: city,
    type: 'year'
  }
}

export default {
  'saleCenter': { title: '营销中心' },
  'saleCenter2': { title: '计划类型' },
  'saleCenter3': { title: '产品分类' },
  'saleCenter4': { title: '计划量汇总' },
  'saleCenter5': { title: '编制使用情况' },
  'saleCenter6': { title: '编制剩余量' }
}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/preparePlanReportForms.js